// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension="
// @generated from file core.proto (package core, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from '@bufbuild/protobuf'
import { Message, proto3 } from '@bufbuild/protobuf'

/**
 * @generated from message core.Error
 */
export class Error extends Message<Error> {
  /**
   * @generated from field: string message = 1;
   */
  message = ''

  /**
   * @generated from field: core.Error.Code code = 2;
   */
  code = Error_Code.UNKNOWN

  constructor(data?: PartialMessage<Error>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'core.Error'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'message', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'code', kind: 'enum', T: proto3.getEnumType(Error_Code) },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Error {
    return new Error().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Error {
    return new Error().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Error {
    return new Error().fromJsonString(jsonString, options)
  }

  static equals(a: Error | PlainMessage<Error> | undefined, b: Error | PlainMessage<Error> | undefined): boolean {
    return proto3.util.equals(Error, a, b)
  }
}

/**
 * @generated from enum core.Error.Code
 */
export enum Error_Code {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: NOT_FOUND = 1;
   */
  NOT_FOUND = 1,

  /**
   * @generated from enum value: ALREADY_EXISTS = 2;
   */
  ALREADY_EXISTS = 2,

  /**
   * @generated from enum value: PERMISSION_DENIED = 3;
   */
  PERMISSION_DENIED = 3,

  /**
   * @generated from enum value: UNAUTHENTICATED = 4;
   */
  UNAUTHENTICATED = 4,

  /**
   * @generated from enum value: INVALID_ARGUMENT = 5;
   */
  INVALID_ARGUMENT = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(Error_Code)
proto3.util.setEnumType(Error_Code, 'core.Error.Code', [
  { no: 0, name: 'UNKNOWN' },
  { no: 1, name: 'NOT_FOUND' },
  { no: 2, name: 'ALREADY_EXISTS' },
  { no: 3, name: 'PERMISSION_DENIED' },
  { no: 4, name: 'UNAUTHENTICATED' },
  { no: 5, name: 'INVALID_ARGUMENT' },
])
